(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-card-flip", [], factory);
	else if(typeof exports === 'object')
		exports["react-card-flip"] = factory();
	else
		root["react-card-flip"] = factory();
})(window, function() {
return 